<!--债券-->
<template>
  <div class="bond-container">
    <div class="bond-content">
      <div class="bond-search-menu">
        <span>搜索到<span style="color: #fe273b">{{ tablePage.total > 5000 ? '5000+' : tablePage.total }}</span>个结果</span>
        <div class="bond-search-right">
          <el-input placeholder="请输入发行人、债券代码、债券名称" v-model="keyword" class="keyword-input" style="width: 345px"
                    @keyup.enter.native="getBondInfo">
            <el-button type="danger" slot="append" @click="getBondInfo">搜索</el-button>
          </el-input>
        </div>
      </div>
      <div class="bond-table">
        <vxe-table :height="Theight" stripe border align="center" :data="bondInfo" :column-config="{resizable: true}"
                   :header-cell-style="{backgroundColor: '#F4F5FD',color: '#333333'}" @cell-click="enterpriseDetails">
          <vxe-column field="bondName" title="债券简称">
            <template #default="{ row }">
              <el-link type="primary" :underline="false">{{ row.bondName }}</el-link>
            </template>
          </vxe-column>
          <vxe-column field="bondCode" title="债券代码" width="150"/>
          <vxe-column field="issuer" title="发行人" show-overflow>
            <template #default="{ row }">
              <el-link type="primary" :underline="false">{{ row.issuer }}</el-link>
            </template>
          </vxe-column>
          <vxe-column field="stockName" title="实际发行量" width="180"/>
          <vxe-column field="startTime" title="债券发行日" width="120"/>
        </vxe-table>
        <div style="padding:10px 10px 0px;">
          <page :total="tablePage.total" @currentPage="currentPage" :limit="tablePage.pageSize" style="float: right;"/>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from 'vue';
import VXETable from 'vxe-table';
import 'vxe-table/lib/index.css';
import page from "@/components/page/pages";
import {bondList} from '@/api/enterprise_searchApi'
Vue.use(VXETable)
export default {
  name: "bond",
  components: {page},
  data() {
    return {
      keyword: '',
      bondInfo: [],
      tablePage: {
        currentPage: 1,
        pageSize: 10,
        total: 0,
      },
      Theight: document.documentElement.clientHeight - 477
    }
  },
  methods: {
    /*获取债券列表*/
    getBondInfo() {
      bondList({
        keyword: this.keyword,
        page: this.tablePage.currentPage,
        pageLimit: this.tablePage.pageSize,
        cityCode: 0,
      }).then(res=>{
        if (res.code==200){
          this.tablePage.total = parseInt(res.content.total);
          this.bondInfo = res.content.rows;
          console.log(res);
        }
      })
    },
    //切换分页
    currentPage(page) {
      this.tablePage.currentPage = page;
      this.getBondInfo();
    },
    /*查看企业详情*/
    enterpriseDetails(event){
      console.log(event.row)
      let routeData = this.$router.resolve({
        name: "enterpriseDetails",
        path: '/enterpriseDetails/index',
        query: {id:event.row.cid}
      });
      window.open(routeData.href, '_blank')
    }
  },
  mounted() {
    this.getBondInfo();
  }
}
</script>
<style scoped>
.bond-container >>> .bond-content .bond-search-menu .el-input__inner {
  background-color: #ffffff;
  border-radius: 6px;
  border: 1px solid #DDDDDD;
  color: #333333;
  font-size: 14px;
  height: 40px;
  line-height: 40px;
  padding: 0 10px;
}
.bond-container >>> .bond-content .bond-search-menu input::-webkit-input-placeholder {
  color: #999999;

}
.bond-container >>> .bond-content .bond-search-menu .el-input__suffix {
  display: flex;
  align-items: center;
  right: 10px;
}
.bond-container >>> .bond-content .bond-search-menu .el-icon-search {
  font-size: 19px;
}
.bond-container >>> .bond-content .bond-search-menu .el-input-group__append,
.bond-container >>> .bond-content .bond-search-menu .el-input-group__prepend {
  background-color: #FE273B;
  color: #fff;
  border: 1px solid #FE273B;
  border-radius: 0px 6px 6px 0px;
  padding: 0 20px;
}
.bond-container >>> .bond-content .bond-search-menu .keyword-input .el-input__inner {
  background-color: #ffffff;
  border: 1px solid #DDDDDD;
  color: #333333;
  font-size: 14px;
  height: 40px;
  line-height: 40px;
  padding: 0 10px;
  border-radius: 6px 0px 0px 6px;
  border-right: none;
}
.bond-container >>> .bond-content .el-link.el-link--primary {
  color: #1637FF;
}
</style>
<style scoped lang="scss">
.bond-container {
  .bond-content {
    .bond-search-menu {
      padding: 20px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-bottom: 1px solid #EBEDF6;
    }
    .bond-table {
      padding: 20px;
    }
  }
}
</style>